<section class="user-details">
  <div class="container-fluid">
    <div class="ud-topbar">
      <app-back-button></app-back-button>
      <!-- <button class="backBtn" (click)="goBack()" title="Back">&#8592;</button> -->
      <!-- routerLink="/dashboard/reports" -->
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="auction-content-main mb-4 mb-md-0 position-relative">

          <ng-container *ngIf="isIndividualAuction">
            <!-- Hero -->
            <div class="ud-hero">
              <span class="ud-status ud-status--approved" *ngIf="!approveRequire && approveStatus">
                <ion-icon name="checkmark-circle"></ion-icon> Approved
              </span>
              <span class="ud-status ud-status--rejected" *ngIf="approveRequire && approveStatus === false">
                <ion-icon name="close-circle"></ion-icon> Rejected
              </span>

              <div class="ud-hero__thumb">
                <img src="{{ getImageUrl }}" alt="" />
              </div>
              <div class="ud-hero__body">
                <h3 class="ud-hero__title">
                  {{ getTitle || productData?.title }}
                </h3>
                <p class="ud-hero__location">
                  <ion-icon name="location-outline"></ion-icon>
                  {{ allData?.location ? allData?.location : "N/A" }}
                </p>
              </div>
            </div>

            <!-- Floating price stats -->
            <div class="ud-stats">
              <div class="ud-stat-card">
                <span class="ud-stat-card__icon"><ion-icon name="shield-checkmark-outline"></ion-icon></span>
                <div class="ud-stat-card__text">
                  <span class="ud-stat-card__label">Reserve Price</span>
                  <span class="ud-stat-card__value">SAR {{ allData?.lowest_price }}</span>
                </div>
              </div>
              <div class="ud-stat-card">
                <span class="ud-stat-card__icon"><ion-icon name="flash-outline"></ion-icon></span>
                <div class="ud-stat-card__text">
                  <span class="ud-stat-card__label">Buy Now Price</span>
                  <span class="ud-stat-card__value">SAR {{ allData?.buy_now_price }}</span>
                </div>
              </div>
              <div class="ud-stat-card">
                <span class="ud-stat-card__icon"><ion-icon name="play-outline"></ion-icon></span>
                <div class="ud-stat-card__text">
                  <span class="ud-stat-card__label">Opening Price</span>
                  <span class="ud-stat-card__value">SAR {{ allData?.opening_price }}</span>
                </div>
              </div>
            </div>

            <div class="auction-content-body px-4 pb-4">
              <div class="ud-section-title">
                <ion-icon name="pricetags-outline"></ion-icon> Additional details
              </div>
              <div class="spec-grid spec-grid--bordered spec-grid--compact">
                <div class="spec-item">
                  <span class="spec-label">Reserve Bid</span>
                  <span class="spec-value">{{ allData?.buy_now_price ? "YES" : "NO" }}</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">Increment Price</span>
                  <span class="spec-value">SAR {{ allData?.incremental_price }}</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">Color</span>
                  <span class="spec-value">
                    {{ allData?.description_data ? allData?.description_data?.["Interior Colour"] :
                    allData?.bulkInfo?.[0]?.ProductInfo[0]?.description_data?.["Interior Colour"] }}
                  </span>
                </div>
              </div>

              <div class="ud-section-title">
                <ion-icon name="construct-outline"></ion-icon> Technical specifications
              </div>
              <div class="spec-grid spec-grid--icons">
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="car-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Body Type</span>
                    <span class="spec-value">
                      {{ allData?.auction_type === "1"
                      ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["Body Type"] :
                      allData?.description_data?.["Body Type"] }}
                    </span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="flash-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Engine</span>
                    <span class="spec-value">
                      {{ allData?.auction_type === "1"
                      ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["Engine Type"] :
                      allData?.description_data?.["Engine Type"] }}
                      {{ allData?.auction_type === "1"
                      ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["Cylinders"] :
                      allData?.description_data?.["Cylinders"] }}
                      {{ allData?.auction_type === "1"
                      ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["HP (Horse Power)"] :
                      allData?.description_data?.["HP (Horse Power)"] }}
                    </span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="color-palette-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Interior</span>
                    <span class="spec-value">
                      {{ allData?.auction_type === "1"
                      ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["Interior Colour"] :
                      allData?.description_data?.["Interior Colour"] }}
                    </span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="settings-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Transmission</span>
                    <span class="spec-value">
                      {{ allData?.auction_type === "1"
                      ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["Transmission Type"] :
                      allData?.description_data?.["Transmission Type"] }}
                    </span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="brush-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Exterior</span>
                    <span class="spec-value">
                      {{ allData?.auction_type === "1"
                      ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["Exterior Colour"] :
                      allData?.description_data?.["Exterior Colour"] }}
                    </span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="navigate-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Drive Type</span>
                    <span class="spec-value">{{
                      allData?.auction_type === "0"
                      ? allData?.ProductInfo?.[0].description_data?.["DriveType"] :
                      allData?.description_data?.["DriveType"]
                      }}</span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="pricetag-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Stock Number</span>
                    <span class="spec-value">57576766</span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="water-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Fuel Type</span>
                    <span class="spec-value">{{
                      allData?.auction_type === "0"
                      ? allData?.ProductInfo?.[0].description_data?.["DriveType"] :
                      allData?.description_data?.["FuelType"]
                      }}</span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="barcode-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">VIN</span>
                    <span class="spec-value">{{
                      allData?.auction_type === "1"
                      ? allData?.bulkInfo[0]?.ProductInfo[0]?.description_data?.["VIN Number"] :
                      allData?.description_data?.["VIN Number"]
                      }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="ud-actions">
              <div class="ud-actions__group" *ngIf="approveRequire && approveStatus === null">
                <button type="button" class="btn-pill btn-pill--green" [disabled]="approveStatus"
                  (click)="updateStatus(activroute, '1')">
                  <ion-icon name="checkmark-outline"></ion-icon> Approve
                </button>
                <button type="button" class="btn-pill btn-pill--red-outline" *ngIf="
                    approveStatus === false || approveStatus === null
                  " [disabled]="approveStatus === false" (click)="updateStatus(activroute, '0')">
                  <ion-icon name="close-outline"></ion-icon> Reject
                </button>
              </div>
              <button type="button" class="btn-pill btn-pill--primary"
                routerLink="/dashboard/auction/edit/{{ activroute }}" [queryParams]="{ type: queryParam }">
                View Auction <ion-icon name="arrow-forward-outline"></ion-icon>
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="isBatchAuction || isBulkAuction">
            <div class="auction-content-body p-4">
              <div class="ud-section-title">
                <ion-icon name="car-sport-outline"></ion-icon> Vehicles in this lot
              </div>
              <div class="vehicle-list">
                <ng-container *ngFor="let vehicle of vehicles; index as i">
                  <div class="vehicle-card" (click)="renderVehicleDetails(vehicle)">
                    <span class="vehicle-card__index">{{ i + 1 }}</span>
                    <div class="vehicle-card__img">
                      <img src="{{ vehicle['frontImg'] || getImageUrl }}" alt="" />
                    </div>
                    <div class="vehicle-card__name">
                      {{ vehicle["vehicleName"] }}
                    </div>
                    <a [routerLink]="[
                        '/dashboard/inventory/vehicle-details',
                        vehicle['product_id']
                      ]" class="vehicle-card__view" (click)="$event.stopPropagation()">
                      <ion-icon name="eye"></ion-icon>
                    </a>
                  </div>
                </ng-container>
              </div>

              <div class="ud-section-title">
                <ion-icon name="pricetags-outline"></ion-icon> Lot pricing
              </div>
              <div class="spec-grid spec-grid--compact">
                <div class="spec-item">
                  <span class="spec-label">Reserve Price</span>
                  <span class="spec-value">SAR {{ currentAuction["lowest_price"] }}</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">Buy Now Price</span>
                  <span class="spec-value">SAR {{ currentAuction?.['buy_now_price'] }}</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">Reserve Bid</span>
                  <span class="spec-value">{{ currentAuction["buy_now_price"] ? "YES" : "NO" }}</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">Increment Price</span>
                  <span class="spec-value">SAR {{ currentAuction?.['incremental_price'] }}</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">Opening Price</span>
                  <span class="spec-value">SAR {{ currentAuction["opening_price"] }}</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">Color</span>
                  <span class="spec-value">
                    {{ currentAuction?.['description_data'] ?
                    currentAuction?.['description_data']?.["Interior Colour"] :
                    currentAuction?.['bulkInfo']?.[0]?.ProductInfo[0]?.description_data?.["Interior Colour"] }}
                  </span>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Render Vehicle Details -->
          <ng-container *ngIf="showVehicleDetails">
            <div class="auction-content-body p-4 pt-0">
              <div class="ud-section-title">
                <ion-icon name="construct-outline"></ion-icon> Technical specifications
              </div>
              <div class="spec-grid spec-grid--icons">
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="car-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Body Type</span>
                    <span class="spec-value">{{ vehicleDetails["Body Type"] }}</span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="flash-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Engine</span>
                    <span class="spec-value">{{ vehicleDetails["Engine Type"] }}</span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="color-palette-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Interior</span>
                    <span class="spec-value">{{ vehicleDetails["Interior Colour"] }}</span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="settings-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Transmission</span>
                    <span class="spec-value">{{ vehicleDetails["Cylinders"] }}</span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="brush-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Exterior</span>
                    <span class="spec-value">{{ vehicleDetails["Exterior Colour"] }}</span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="navigate-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Drive Type</span>
                    <span class="spec-value">{{ vehicleDetails["Drive Type"] }}</span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="pricetag-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Stock Number</span>
                    <span class="spec-value">57576766</span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="water-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Fuel Type</span>
                    <span class="spec-value">{{ vehicleDetails["Fuel Type"] }}</span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="barcode-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">VIN</span>
                    <span class="spec-value">{{ vehicleDetails["VIN Number"] }}</span>
                  </div>
                </div>
                <div class="spec-item">
                  <span class="spec-item__icon"><ion-icon name="speedometer-outline"></ion-icon></span>
                  <div class="spec-item__text">
                    <span class="spec-label">Horse Power</span>
                    <span class="spec-value">{{ vehicleDetails["HP (Horse Power)"] }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="ud-actions">
              <div class="ud-actions__group" *ngIf="approveRequire && approveStatus === null">
                <button type="button" class="btn-pill btn-pill--green" [disabled]="approveStatus"
                  (click)="updateStatus(activroute, '2')">
                  <ion-icon name="checkmark-outline"></ion-icon> Approve
                </button>
                <button type="button" class="btn-pill btn-pill--red-outline" *ngIf="
                    approveStatus === false || approveStatus === null
                  " [disabled]="approveStatus === false" (click)="updateStatus(activroute, '0')">
                  <ion-icon name="close-outline"></ion-icon> Reject
                </button>
              </div>
              <button type="button" class="btn-pill btn-pill--primary"
                routerLink="/dashboard/auction/edit/{{ activroute }}" [queryParams]="{ type: queryParam }">
                View Auction <ion-icon name="arrow-forward-outline"></ion-icon>
              </button>
            </div>
          </ng-container>
        </div>
      </div>

      <ng-container *ngIf="bidHistoryData.length">
        <div class="col-md-6 auction-content-main">
          <tabset class="ud-tabset">
            <tab heading="Bid History">
              <div>
                <div class="auction-content-body p-4">
                  <div class="timeLineBox">
                    <ul class="list-unstyled timeLine">
                      <li class="timeLine__item" *ngFor="let bidHistory of bidHistoryData; index as i">
                        <div class="timeLine__date px-2">
                          {{dateFormatter(bidHistory?.['created_at'])}}
                        </div>
                        <div class="timeLine__data flex-column">
                          <h5 class="fs-sm fw-600 mb-1 text-capitalize" *ngIf="bidHistory['first_name']">
                            {{ bidHistory["first_name"] }}
                            {{ bidHistory["last_name"] }}
                          </h5>
                          <h5 class="fs-sm fw-600 mb-0">
                            BID: SAR {{ bidHistory["Bidding_amount"] }}
                          </h5>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </tab>

            <tab heading="Documents">
              <div *ngIf="paymentDoc?.length; else noDocument">
                <div class="auction-content-body p-4">
                  <div class="timeLineBox">
                    <ul class="list-unstyled doc-list">
                      <ng-container *ngFor="let document of paymentDoc; index as i">
                        <li class="doc-item" [ngClass]="{
                            'doc-item--approved': document['payment_doc_status'] === true,
                            'doc-item--rejected': document['payment_doc_status'] === false,
                            'doc-item--pending': document['payment_doc_status'] === null
                          }">
                          <span class="doc-item__status-icon">
                            <ion-icon *ngIf="document['payment_doc_status'] === true"
                              name="checkmark-circle"></ion-icon>
                            <ion-icon *ngIf="document['payment_doc_status'] === false" name="close-circle"></ion-icon>
                            <ion-icon *ngIf="document['payment_doc_status'] === null" name="time-outline"></ion-icon>
                          </span>

                          <div class="doc-item__info">
                            <h5 class="doc-item__name">
                              {{ document["document_name"] }}
                            </h5>
                            <p class="doc-item__date">
                              {{
                              document["created_at"]
                              | date: "MMM d, y, h:mm a"
                              }}
                            </p>
                          </div>

                          <div class="doc-item__actions">
                            <button type="button" class="btn-pill btn-pill--outline" (click)="
                                viewPaymentDoc(
                                  document['imageUrl']['presigned_url']
                                )
                              ">
                              View
                            </button>

                            <button *ngIf="
                                document['payment_doc_status'] === null ||
                                document['payment_doc_status'] === true
                              " type="button" class="btn-pill btn-pill--green"
                              [disabled]="document['payment_doc_status']" (click)="
                                updatePaymentDocStatus(
                                  1,
                                  i,
                                  document['doc_id'],
                                  document['document_name']
                                )
                              ">
                              {{
                              document["payment_doc_status"] === true
                              ? "Approved"
                              : "Approve"
                              }}
                            </button>

                            <button *ngIf="
                                document['payment_doc_status'] === null ||
                                document['payment_doc_status'] === false
                              " type="button" class="btn-pill btn-pill--red" [disabled]="
                                document['payment_doc_status'] === false
                              " (click)="
                                openRejectWhyModal(
                                  rejectReasonModal,
                                  i,
                                  document['doc_id'],
                                  document['document_name']
                                )
                              ">
                              {{
                              document["payment_doc_status"] === false
                              ? "Rejected"
                              : "Reject"
                              }}
                            </button>
                          </div>
                        </li>
                      </ng-container>

                      <ng-container *ngIf="paymentDocStaus">
                        <ng-container *ngFor="
                            let doc of globalDocsObj | keyvalue;
                            index as i
                          ">
                          <li class="doc-item" [ngClass]="{ 'doc-item--approved': doc['value']['available'] }">
                            <span class="doc-item__status-icon">
                              <ion-icon *ngIf="doc['value']['available']" name="checkmark-circle"></ion-icon>
                              <ion-icon *ngIf="!doc['value']['available']" name="cloud-upload-outline"></ion-icon>
                            </span>

                            <div class="doc-item__info">
                              <h5 class="doc-item__name">
                                {{ doc["key"] }}
                              </h5>
                              <p *ngIf="doc['value']['available']" class="doc-item__date">
                                {{
                                doc["value"]["uploadTime"]
                                | date: "MMM d, y, h:mm a"
                                }}
                              </p>
                              <input *ngIf="!doc['value']['available']" class="doc-item__file mb-2" type="file"
                                accept="image/jpeg,image/jpg,image/png, .pdf"
                                (change)="getDocument($event, doc['key'])" />
                            </div>

                            <div class="doc-item__actions">
                              <button *ngIf="!doc['value']['available']" class="btn-pill btn-pill--primary"
                                [disabled]="!doc['value']['enableUpload']" [ladda]="laddaBtns[i]" (click)="
                                  uploadDocument(activroute, doc['key'], i)
                                " title="Upload {{ doc['key'] }}">
                                Upload
                              </button>
                              <button *ngIf="doc['value']['available']" class="btn-pill btn-pill--outline" (click)="
                                  viewInvoice(doc['value']['imageUrl'])
                                " title="View {{ doc['key'] }}">
                                View
                              </button>
                              <button [disabled]="!doc['value']['available']" class="btn-pill btn-pill--red"
                                [ladda]="laddaBtns[i]" (click)="
                                  deleteAdminDoc(
                                    activroute,
                                    doc['value']['id'],
                                    doc['key'],
                                    i
                                  )
                                " title="Delete {{ doc['key'] }}">
                                Delete
                              </button>
                            </div>
                          </li>
                        </ng-container>
                      </ng-container>
                    </ul>
                  </div>
                </div>
              </div>

              <ng-template #noDocument>
                <div class="empty-state">
                  <ion-icon name="document-text-outline"></ion-icon>
                  <h3>No document yet!</h3>
                </div>
              </ng-template>
            </tab>

            <tab heading="Return Request">
              <div class="empty-state">
                <ion-icon name="time-outline"></ion-icon>
                <h3>Coming soon</h3>
              </div>
            </tab>
          </tabset>
        </div>
      </ng-container>
    </div>
  </div>
</section>
<app-loader *ngIf="loading"></app-loader>

<!-- Reject Reason Modal -->
<ng-template #rejectReasonModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left p-0 fs-lg">Why reject?</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="modalRef?.hide()">
      <span aria-hidden="true" class="visually-hidden"><ion-icon name="close-outline"></ion-icon></span>
    </button>
  </div>
  <div class="modal-body">
    <div>
      <textarea class="w-100 border reject-txt-area p-2 text-dark" cols="30" rows="10" [(ngModel)]="whyReject"
        placeholder="Please describe why document is rejected"></textarea>
      <div class="d-flex flex-row-reverse mt-2">
        <button class="btn-pill btn-pill--primary ml-2" [ladda]="rejectLaddaBtn" (click)="onSubmitReject()">
          Submit
        </button>
        <button class="btn-pill btn-pill--outline" (click)="modalRef?.hide()">
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>